import { FunctionComponent } from "react";

import { FontIcon, Stack, Text, useTheme } from "@bps/fluent-ui";
import { ServerMigrationStep } from "@libs/api/gateways/field/field-ops-gateway.dtos";

interface ServerMigrationStepsProps {
  title: string;
  steps: ServerMigrationStep[];
}

export const ServerMigrationSteps: FunctionComponent<ServerMigrationStepsProps> = ({
  title,
  steps
}) => {
  const theme = useTheme();

  return (
    <Stack tokens={{ childrenGap: theme.spacing.s1 }}>
      <Text variant="mediumPlus">{title} steps</Text>
      {!steps.length && <Text>No steps were returned.</Text>}
      <Stack
        tokens={{ childrenGap: theme.spacing.s1 }}
        styles={{ root: { maxHeight: 280, overflowY: "auto" } }}
      >
        {steps.map((step, index) => (
          <Stack
            // Steps have no id and messages can repeat, so the index is the key.
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            horizontal
            tokens={{ childrenGap: theme.spacing.s1 }}
          >
            <FontIcon
              iconName={step.success ? "CompletedSolid" : "StatusErrorFull"}
              styles={{
                root: {
                  paddingTop: 2,
                  color: step.success
                    ? theme.semanticColors.successIcon
                    : theme.semanticColors.errorIcon
                }
              }}
            />
            <Text styles={{ root: { wordBreak: "break-word" } }}>
              {step.message}
            </Text>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
